var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00043 8.71582L6.64688 9.06937L7.00043 9.42293L7.35398 9.06937L7.00043 8.71582ZM7.50043 1.00111C7.50043 0.724962 7.27657 0.501105 7.00043 0.501105C6.72429 0.501105 6.50043 0.724962 6.50043 1.0011L7.50043 1.00111ZM2.36092 4.78342L6.64688 9.06937L7.35398 8.36227L3.06803 4.07631L2.36092 4.78342ZM7.35398 9.06937L11.6399 4.78342L10.9328 4.07631L6.64688 8.36227L7.35398 9.06937ZM7.50043 8.71582L7.50043 1.00111L6.50043 1.0011L6.50043 8.71582L7.50043 8.71582Z",
    fill: "#15993E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.42871L1 9.2859C1 10.2327 1.76755 11.0003 2.71438 11.0003L11.2863 11.0003C12.2331 11.0003 13.0007 10.2327 13.0007 9.2859V8.42871",
    stroke: "#15993E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.a1d50cd55bc7e62e73242e2102eee662.svg";
export { ForwardRef as ReactComponent };